import IconButton from '@mui/material/IconButton';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { setDefaultSettings } from 'app/store/fuse/settingsSlice';
import _ from '@lodash';
import { navbarToggleMobile, navbarToggle } from '../../store/fuse/navbarSlice';
import PropTypes from 'prop-types';

function NavbarToggleButton({ children = <FuseSvgIcon>menu_open</FuseSvgIcon>, className }) {
	const dispatch = useDispatch();
	const theme = useTheme();
	const mdDown = useMediaQuery(theme.breakpoints.down('md'));
	const settings = useSelector(({ fuse }) => fuse.settings.current);
	const { config } = settings.layout;

	const handleToggle = () => {
		if (mdDown) {
			dispatch(navbarToggleMobile());
		} else if (config.navbar.style === 'style-2') {
			dispatch(
				setDefaultSettings(_.set({}, 'layout.config.navbar.folded', !settings.layout.config.navbar.folded))
			);
		} else {
			dispatch(navbarToggle());
		}
	};

	return (
		<IconButton
			className={className}
			onClick={handleToggle}
			color="inherit"
			size="small"
		>
			{children}
		</IconButton>
	);
}

NavbarToggleButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default NavbarToggleButton;
